<template>
    <div class="activityRules">
        <div class="awardRules rules">
            <div class="rules-title">
                <h4>活动规则</h4>
            </div>
            <div class="awardRules-main">
                <template v-for="(i, n) in awardRulesText">
                    <h5 :key="'h5' + n" v-show="i.title">{{ i.title }}</h5>
                    <p :key="'p' + n" class="awardRules-text"  v-html="i.text"></p>
                </template>

                <h5>活动须知</h5>
                <ul class="rules-ul">
                    <li v-for="(i, index) in awardRules" :key="index">
                        <i>{{ index + 1 }}.</i>
                        <p v-html="i"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "activityRules",
    data() {
        return {
            awardRulesText: [
                {
                    title: "活动时间",
                    text: "1月6日-1月12日"
                },
                {
                    title: "参与方式",
                    text: "在本帖下方评论区回复，晒出自己的2022年度游民关键词，即视为参与活动。"
                },
                {
                    title: "活动奖励",
                    text: "50元 京东卡*10"
                },

            ],
            awardRules: [
                "回复中晒出的2022年度游戏报告需为自己的专属年度游戏报告，不可盗用、冒用其他用户的年度报告，如有发现，将取消其活动资格；",
                "禁止刷帖行为，如有发现，将取消其活动资格；",
                "抽奖方式为使用百度随机生成数，随机抽取所有回复楼层数中的10名用户，活动结束后将在本帖进行开奖；",
                "获奖名单在活动结束后由官方在活动帖内进行公布，并通过站内信的方式告知中奖用户，请各位游民用户及时查看；",
                "奖品无法兑换其他道具或现金；",
                `发文需遵守游民圈子总版规<a style="color:#f53f3f" target="_blank" href="https://club.gamersky.com/activity/618090?club=1468">【网页链接】</a>，违规行为将被删帖/封号等处罚。</b>`
            ]
        };
    },
};
</script>
<style lang="scss" scoped>
.ruleA {
      color: #f53f3f;
  }
.activityRules {
    width: 391px;
    .rules {
        padding: 0 25px 20px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 10px;
        &:last-of-type {
            margin: 0;
        }
        .rules-title {
            position: relative;
            margin-bottom: 10px;
            height: 58px;
            border-bottom: 1px solid #eee;
            overflow: visible;
            h4 {
                line-height: 58px;
                color: #444;
                font-size: 18px;
            }
            i {
                display: block;
                width: 147px;
                height: 23px;
                position: absolute;
                right: -5px;
                top: 18px;
                background-image: url(//image.gamersky.com/webimg13/zhuanti/wqj2020/pc/isyou.png);
                background-repeat: no-repeat;
            }
        }
        .rules-ul {
            width: 100%;
            overflow: hidden;
            li {
                margin-bottom: 15px;
                padding-left: 22px;
                position: relative;
                overflow: hidden;
                i {
                    line-height: 24px;
                    color: #333;
                    font-size: 14px;
                    font-weight: 700;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                p {
                    line-height: 24px;
                    color: #333;
                    font-size: 14px;
                    text-align: justify;
                }
                &:first-of-type {
                    p {
                        font-weight: 700;
                    }
                }
            }
          
        }
                
        .awardRules-main {
            .awardRules-text {
                line-height: 24px;
                color: #333;
                font-size: 14px;
                margin-top: 5px;
                &.ffc555 {
                    color: #ffc555;
                    margin-top: 10px;
                    font-weight: bold;
                }
            }
            h5 {
                line-height: 30px;
                color: #333;
                font-size: 14px;
            }
            .rules-ul {
                li {
                    &:first-of-type {
                        p {
                            font-weight: normal;
                        }
                    }
                }
            }
        }
        .award-btn {
            margin: 0 auto 15px;
            display: block;
            width: 300px;
            height: 42px;
            line-height: 42px;
            color: #433e47;
            font-size: 18px;
            text-align: center;
            border-radius: 20px;
            background: url("//image.gamersky.com/webimg13/zhuanti/wqj2020/pc/cjbtn.png") no-repeat;
            box-shadow: 0 20px 24px 0 rgba(158, 111, 20, 0.2);
            &:hover {
                background-position-y: -42px;
            }
            &.stop {
                color: #aaa;
                background: #f2f2f3;
                border: 1px solid #cecece;
                cursor: default;
            }
        }
        .lotteryCount {
            text-align: center;
            font-size: 14px;
            color: #aaa;
        }
    }
}
</style>
